"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registry = void 0;
const react_sweet_state_1 = require("react-sweet-state");
const isomorphic_1 = require("../../isomorphic");
const utils_1 = require("../../utils");
const components_1 = require("../components");
const stores_1 = require("../stores");
const initializeClientsideRegistry = (scope) => {
    isomorphic_1.LOGGER.info('Initializing client store state registry within registry object...');
    const initialConfigState = (0, components_1.getInitialState)((0, stores_1.getInitialStateName)(stores_1.CONFIG_STORE_NAME));
    const initialShoppingPortalState = (0, components_1.getInitialState)((0, stores_1.getInitialStateName)(stores_1.SHOPPING_PORTAL_STORE_NAME));
    const initialWebLabState = (0, components_1.getInitialState)((0, stores_1.getInitialStateName)(stores_1.WEBLAB_STORE_NAME));
    const configActionsStates = scope
        ? react_sweet_state_1.defaultRegistry.getStore(stores_1.configStore, scope)
        : react_sweet_state_1.defaultRegistry.getStore(stores_1.configStore);
    configActionsStates.actions.init(initialConfigState);
    const shoppingPortalActionsStates = scope
        ? react_sweet_state_1.defaultRegistry.getStore(stores_1.shoppingPortalStore, scope)
        : react_sweet_state_1.defaultRegistry.getStore(stores_1.shoppingPortalStore);
    shoppingPortalActionsStates.actions.init(initialShoppingPortalState);
    const weblabActionsStates = scope
        ? react_sweet_state_1.defaultRegistry.getStore(stores_1.weblabStore, scope)
        : react_sweet_state_1.defaultRegistry.getStore(stores_1.weblabStore);
    weblabActionsStates.actions.init(initialWebLabState);
    isomorphic_1.LOGGER.info('Initialization of client-side store state registry complete');
};
const getStore = (store, scope) => {
    if ((0, utils_1.isClientSide)() && react_sweet_state_1.defaultRegistry.stores.size === 0) {
        initializeClientsideRegistry(scope);
    }
    const { actions, storeState } = scope ? react_sweet_state_1.defaultRegistry.getStore(store, scope) : react_sweet_state_1.defaultRegistry.getStore(store);
    return {
        getActions: () => actions,
        getState: () => storeState.getState()
    };
};
const deleteStore = (store, scope) => scope ? react_sweet_state_1.defaultRegistry.deleteStore(store, scope) : react_sweet_state_1.defaultRegistry.deleteStore(store);
const initStore = (store, key) => react_sweet_state_1.defaultRegistry.initStore(store, key);
exports.registry = {
    deleteStore,
    getStore,
    initStore,
    stores: react_sweet_state_1.defaultRegistry.stores
};
